import store from '../../index';

export function isInputWithTranslations(input) {
  try {
    return Object.keys(JSON.parse(input.value)).some(key => key === store.state.currentLocale);
  } catch {
    return false;
  }
}

export function isEmptyInputWithTranslations(input) {
  if (!isInputWithTranslations(input)) return true;
  return Object.values(JSON.parse(input.value)).some(v => !v);
}

export function isEmptyInputByCurrentLang(input) {
  if (!isInputWithTranslations(input)) return true;
  const value = JSON.parse(input.value);
  return !value[store.state.currentLocale];
}
